<template>
  <div class="image-credits text-dark">
    <p class="font-bold" v-html="$t('welcome.image_credits')">Image credits:</p>
    <ul class="list-disc list-inside">
      <li>Prof. Dr. med. Reinhard Dummer</li>
      <li>
        International Skin Imaging Collaboration. SIIM-ISIC 2020 Challenge
        Dataset. International Skin Imaging Collaboration
        <a href="https://doi.org/10.34970/2020-ds01" target="_blank"
          >https://doi.org/10.34970/2020-ds01</a
        > (2020). 
        {{ $t('welcome.credits_license') }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ImageCredits",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.image-credits {
  font-size: 0.5rem;
  text-align: left;
}
</style>
